import PartnershipsManagement from './PartnershipsManagement'

export default PartnershipsManagement
